// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import SelectWorkOrderWorkTypes from '../../workOrderEditElements/selectWorkOrderWorkTypes';
import FieldLabel from '../../FieldLabel';
import {
  normalizeWorkTypesValue,
  workTypesNeedNormalization,
} from '../../../../utils/normalizeWorkTypes';

const WorkTypesField = (field) => {
  useEffect(() => {
    const currentValue = field?.input?.value;
    if (workTypesNeedNormalization(currentValue)) {
      field.input.onChange(normalizeWorkTypesValue(currentValue));
    }
  }, [field?.input?.value]);

  const selectValue = Array.isArray(field.input.value) ? field.input.value : [];

  return (
    <>
      <FieldLabel
        label={field.label}
        className={field.labelClassName}
        required={field.required}
      />
      <SelectWorkOrderWorkTypes
        value={selectValue}
        onChange={field.input.onChange}
        toolsElementClass={field.toolsElementClass}
        deleteElementIconColor={field.deleteElementIconColor}
      />
      {
        field.meta.touched && field.meta.error
        && <span style={{ color: 'red' }} className="span-error">{field.meta.error}</span>
      }
    </>
  );
};

export default WorkTypesField;
